import { Component, Input } from '@angular/core';
import { composeIBAN } from 'ibantools'
import * as QRCode from 'qrcode';
import { LoggerService } from 'src/app/services/logger/logger.service';

@Component({
  selector: 'libero-qr-payment',
  templateUrl: './qr-payment.component.html',
  styleUrls: ['./qr-payment.component.scss'],
  standalone: false
})
export class QrPaymentComponent {
  @Input() public variableSymbol!: string;
  @Input() public specificSymbol?: string;
  @Input() public accountNumber!: string;
  @Input() public amount?: number;
  @Input() public bankCode!: string;
  @Input() public currency!: 'CZK' | 'EUR';

  public qrImageData: string | null = null;

  public constructor(
    private loggerService: LoggerService,
  ) { }

  public getQrString(): void {
    const accountNumberTokens = this.accountNumber.split('-')

    let paddedPrefix
    let paddedAccountNumber

    if (accountNumberTokens.length === 1) {
      if (accountNumberTokens[0].length > 10) {
        this.loggerService.error('BWM QR: Passed account number is longer than 10 characters!', accountNumberTokens[0]);
      }

      paddedPrefix = ''.trim().padStart(6, '0')
      paddedAccountNumber = accountNumberTokens[0].slice(0, 10).trim().padStart(10, '0')
    } else {
      if (accountNumberTokens[1].length > 10) {
        this.loggerService.error('BWM QR: Passed account number is longer than 10 characters!', accountNumberTokens[1]);
      }

      paddedPrefix = accountNumberTokens[0].trim().padStart(6, '0')
      paddedAccountNumber = accountNumberTokens[1].slice(0, 10).trim().padStart(10, '0')
    }

    const bban = `${this.bankCode}${paddedPrefix}${paddedAccountNumber}`
    const iban = composeIBAN({countryCode: 'CZ', bban: bban})

    let qrData = `SPD*1.0*ACC:${iban}${ this.amount ? '*AM:' + this.amount : ''}*CC:${this.currency}*X-VS:${this.variableSymbol}*`;

    if(this.specificSymbol) {
      qrData += `X-SS:${this.specificSymbol}*`;
    }

    QRCode.toDataURL(qrData)
      .then(url => {
        this.qrImageData = url;
      })
      .catch(err => {
        console.error(err)
      })
  }

}
